module.exports = __webpack_public_path__ + "static/media/kz.7dc54aa2.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/kz.svg
// module id = 2137
// module chunks = 0